module.exports = __webpack_public_path__ + "img/complete_arc_trans_dark.37c44f9b.svg";